<template>
  <div class="content__wrapper">
    <div class="blue-background__wrapper">
      <div class="left-part-of-main-screen-search">
        <div class="home-page-main-text-wrapper">
          <h1 v-if="!(deviceType === 'mobile')" class="display">
            {{ t("home_page.FAIR_title") }}
          </h1>
          <Search />

          <template v-if="!(deviceType === 'desktop')">
            <Button
              label="How to use our search? "
              severity="info"
              @click="visible = true"
              class="show-how-to-use-search button"
            />
            <Dialog
              v-model:visible="visible"
              :pt="dialogSpecificPt"
              modal
              header="How to use our search?"
            >
              <tutorial-how-to-use-search />
            </Dialog>
          </template>

          <div class="search-popular-suggestions">
            <Button
              v-for="(suggestionItem, index) in tempSuggestions"
              class="nowrap button"
              :label="suggestionItem"
              :key="index"
              severity="help"
              rounded
            />
          </div>
        </div>
      </div>
      <div class="learning-carousel-wrapper">
        <template v-if="deviceType === 'desktop'">
          <tutorial-how-to-use-search />
        </template>
      </div>
    </div>
    <recommendations-wrapper />
    <subscribe-form />
  </div>
</template>

<script setup lang="ts">
import Button from "primevue/button";
import Dialog from "primevue/dialog";

import RecommendationsWrapper from "@/widgets/home/Recommended/RecommendationsWrapper.vue";
import Search from "@/features/search/ui/Search.vue";
import SubscribeForm from "@/widgets/home/SubscribeForm/SubscribeForm.vue";
import { useI18n } from "vue-i18n";
import { useDevice } from "@/composables/useDevice";
import TutorialHowToUseSearch from "@/features/search/widgets/tutorial/TutorialHowToUseSearch.vue";
import { computed, ref, watch } from "vue";

const { t } = useI18n();
const { isDevice } = useDevice();
const deviceType = computed(() => {
  if (isDevice.value === "desktop" || isDevice.value === "smallDesktop") return "desktop";
  return "mobile";
});

const visible = ref(false);

const tempSuggestions = ref([
  "blue dress",
  "Baleciaga jeans",
  "Louis Vuitton bag",
  "Dior perfume",
  "denim skirt",
  "Acne Studious shirt",
  "Baleciaga jeans",
]);
const dialogSpecificPt = {
  root: {
    class: "custom-background",
    style: {
      maxHeight: "100vh",
      maxWidth: "100vw",
      width: "100vh",
      height: `Auto`,
    },
  },
  header: {
    class: "title",
  },
  content: {
    style: {
      padding: "8px",
    },
  },
};
</script>

<style scoped>
.content__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.home-page-main-text-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
}

:deep(.search__wrapper) {
  width: 90%;
}

.display {
  white-space: nowrap;
  color: var(--active-100);
  margin: 0;
}

.body {
  color: var(--white-40);
}

.blue-background__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: url("../../assets/img/HomePageBackground.webp");
  background-size: 100% 100%;
  padding: 120px 4% 80px 4%;
  gap: 40px;
  min-height: 720px;
  max-height: 920px;
}

.left-part-of-main-screen-search {
  display: flex;
  flex-direction: column;
  width: 50%;
  justify-content: center;
  align-items: center;
}

.learning-carousel-wrapper {
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.search-popular-suggestions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 40px 0 0 0;
  scrollbar-width: none; /* для Firefox */
  -ms-overflow-style: none; /* для IE и Edge */
}

.nowrap {
  flex-shrink: 0;
}

.show-how-to-use-search {
  margin-top: 20px;
}

@media screen and (max-width: 1024px) {
  .blue-background__wrapper {
    min-height: 570px;
    gap: 0;
  }

  .left-part-of-main-screen-search {
    width: 100%;
  }

  .search__wrapper {
    position: relative;
  }

  .search-popular-suggestions {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    overflow-x: auto;
    flex-wrap: unset;
    max-width: 90%;
    min-width: 0;
    padding: 20px;
  }

  .custom-background {
    background-image: url("../../assets/img/HomePageBackground.webp");
    background-size: 100% 100%;
  }
}

@media (max-width: 767px) {
  .learning-carousel-wrapper {
    display: none;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .learning-carousel-wrapper {
    display: none;
  }
}

@media (min-width: 1025px) and (max-width: 1365px) {
  .learning-carousel-wrapper {
  }
}

@media (min-width: 1366px) and (max-width: 1439px) {
  .learning-carousel-wrapper {
  }
}

@media (min-width: 1440px) and (max-width: 1919px) {
  .learning-carousel-wrapper {
  }
}

@media (min-width: 1920px) {
  .blue-background__wrapper {
    min-height: 900px;
  }
}


@media (min-width: 1024px) {
  .home-page-main-text-wrapper {
    min-height: 64vh;
    justify-content: space-between;
    gap:252px;
  }

  :deep(.search__wrapper) {
    width: 100%;
    position: absolute;
    top:15%;
  }

  /* При раскрытии поиска блок растёт и перекрывает кнопки подсказок */

}
</style>
